import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { PreviewGateService } from '../services/preview-gate.service';

@Injectable({
  providedIn: 'root'
})
export class PreviewGateGuard implements CanActivate {

  constructor(private readonly previewGateService: PreviewGateService) {
  }

  canActivate(): boolean {
    return !this.previewGateService.isBlocked();
  }

}


